import { Plus } from 'lucide-react';
import { LiksButton } from '../../components/liks/LiksButton/LiksButton';
import { LiksDropdown } from '../../components/liks/LiksDropdown/LiksDropdown';
import type { KnowledgeMemberRole } from '../../types/knowledge';

type GroupOption = {
  value: string;
  label: string;
};

type RoleOption = {
  value: KnowledgeMemberRole;
  label: string;
};

type KnowledgeDatabaseGroupAssignFormProps = {
  selectedGroupId: string;
  selectedRole: KnowledgeMemberRole;
  availableGroupOptions: GroupOption[];
  roleOptions: RoleOption[];
  pendingKey: string | null;
  translate: (key: string, params?: Record<string, string>) => string;
  onSelectedGroupIdChange: (value: string) => void;
  onSelectedRoleChange: (value: KnowledgeMemberRole) => void;
  onAssign: () => void;
};

export function KnowledgeDatabaseGroupAssignForm({
  selectedGroupId,
  selectedRole,
  availableGroupOptions,
  roleOptions,
  pendingKey,
  translate,
  onSelectedGroupIdChange,
  onSelectedRoleChange,
  onAssign,
}: KnowledgeDatabaseGroupAssignFormProps) {
  return (
    <div className="knowledge-group-assignments__assign">
      <LiksDropdown
        className="knowledge-group-assignments__group-select"
        variant="on-light"
        value={selectedGroupId}
        onChange={onSelectedGroupIdChange}
        options={availableGroupOptions}
        placeholder={translate('knowledge.members.selectGroupPlaceholder')}
        filterable
        filterPlaceholder={translate(
          'knowledge.members.selectGroupPlaceholder',
        )}
        filterAriaLabel={translate('knowledge.members.searchGroupsLabel')}
        filterEmptyLabel={translate('knowledge.members.filterGroupsEmpty')}
        filterClearLabel={translate('common.search.clear')}
        aria-label={translate('knowledge.members.selectGroupLabel')}
        disabled={availableGroupOptions.length === 0}
      />
      <LiksDropdown
        className="knowledge-group-assignments__role"
        variant="on-light"
        value={selectedRole}
        onChange={(value) => {
          onSelectedRoleChange(value as KnowledgeMemberRole);
        }}
        options={roleOptions}
        aria-label={translate('knowledge.members.inviteGroupRoleLabel')}
      />
      <LiksButton
        type="button"
        disabled={
          selectedGroupId === '' ||
          pendingKey === selectedGroupId ||
          availableGroupOptions.length === 0
        }
        onClick={onAssign}
      >
        <Plus strokeWidth={2} aria-hidden />
        {translate('knowledge.members.assignGroup')}
      </LiksButton>
    </div>
  );
}
